export interface INachfolgeplanungAgtItem {
    agtId?: number;
}

export const findNachfolgeplanungAgtItem = <T extends INachfolgeplanungAgtItem>(
    items: T[] | undefined,
    agtId?: number
): T | undefined => {
    if (!items || agtId === undefined || agtId === null) {
        return undefined;
    }

    return items.find((item) => item.agtId === agtId);
};
